import { action, makeAutoObservable } from 'mobx';

import { CustomGradeCode } from '@/customGrading/constants/customGradeCodes';

import CustomGradingAPI from '../api/CustomGradingAPI';
import GradeAttribute from '../entity/GradeAttribute';

export default class CustomGradeAttributeStore {
  attributes: Partial<Record<CustomGradeCode, GradeAttribute>> = {};

  promises: Partial<Record<CustomGradeCode, Promise<GradeAttribute>>> = {};

  private customGradingAPI: CustomGradingAPI;

  constructor() {
    makeAutoObservable<CustomGradeAttributeStore, 'customGradingAPI'>(this, {
      customGradingAPI: false,
    });

    this.customGradingAPI = new CustomGradingAPI();
  }

  fetchItem = (customGradeCode: CustomGradeCode) => {
    if (this.promises[customGradeCode]) {
      return this.promises[customGradeCode];
    }

    this.promises[customGradeCode] = this.customGradingAPI.fetchCustomGradeAttribute(customGradeCode).then(
      action((res) => {
        const gradeAttribute = new GradeAttribute({ ...res.content, code: customGradeCode });

        this.attributes[customGradeCode] = gradeAttribute;

        return gradeAttribute;
      }),
    );

    return this.promises[customGradeCode];
  };
}

// TODO move
export const customGradeAttributeStore = new CustomGradeAttributeStore();
